<template>
  <v-container v-if="personal">
    <v-row>
      <v-col lg="5" offset-lg="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Resultados C3</v-card-title>
          <v-card-text>
            <v-container>
              <v-row dense>
                <v-col cols="12" align="center">
                  <div class="text-subtitle-1 font-weight-bold section-label">
                    Fecha de emisión C3 <span class="red--text">*</span>
                  </div>
                  <v-date-picker
                    class="modern-date-picker"
                    v-model="fechaElegida"
                    locale="es"
                    color="secondary"
                    no-title
                    full-width
                    :rules="required"
                  ></v-date-picker>
                </v-col>
                <v-col cols="12" class="pa-0 my-0">
                  <v-select
                    class="ui-form-field modern-input"
                    v-model="resultadoElegido"
                    dense
                    filled
                    rounded
                    color="secondary"
                    background-color="transparent"
                    :items="resultados"
                    item-value="title"
                    item-text="title"
                    item-color="secondary"
                    :rules="required"
                  >
                    <template v-slot:label>Resultado <span class="red--text">*</span> </template>
                  </v-select>
                </v-col>
                <v-col cols="12" align="center" class="pa-0 my-0">
                  <v-textarea
                    class="ui-form-field modern-input"
                    v-model="observaciones"
                    no-resize
                    rows="3"
                    color="secondary"
                    background-color="transparent"
                    label="Observaciones (Opcional)"
                    rounded
                    filled
                    dense
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center ui-module-actions">
            <v-btn text class="error--text mb-4 mx-8 ui-module-btn-text-danger" v-on:click="$router.push(rutaRetorno)">Cancelar</v-btn>
            <v-btn
              color="secondary"
              class="primary--text px-8 mb-4 ui-module-btn-solid"
              :loading="loading"
              :disabled="!resultadoElegido || !fechaElegida || loading"
              v-on:click="triggerAsignacionTurno()"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_PERSONAL_FOTO_CUIP(this.id)
    await this.fetchPersonalById(this.id)
  },

  data() {
    return {
      loading: false,
      fechaElegida: null,
      resultadoElegido: null,
      observaciones: '',

      resultados: [
        { id: 1, title: 'Aprobado' },
        { id: 2, title: 'No aprobado' },
        { id: 3, title: 'No cubre perfil' },
        { id: 3, title: 'Sí cubre perfil' },
      ],

      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  computed: {
    ...mapGetters('personal', {
      personalFotoCuip: 'getPersonalFotoCuip',
      personalSingle: 'getPersonalSingle',
    }),
    personal() {
      return this.personalSingle
    },
    rutaRetorno() {
      return this.$route.query.from === 'nuevos-ingresos' ? '/enlace_c3/nuevos-ingresos' : '/enlace_c3/personal'
    },
  },

  methods: {
    ...mapActions('resultadosPersonalesC3', ['createResultado']),
    ...mapActions('personal', ['updatePersonal', 'updatePuestoPersonal', 'fetchPersonal', 'fetchPersonalById']),
    ...mapMutations('personal', ['SET_PERSONAL_FOTO_CUIP']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('notificaciones', ['createNotification']),

    async triggerAsignacionTurno() {
      this.loading = true
      const resultado = {
        resultado: this.resultadoElegido,
        fechaVigenciaEvaluacionC3: this.fechaElegida,
        observaciones: this.observaciones,
      }
      await this.updatePersonal({ ...this.personal, vigenciaEvaluacionC3: this.fechaElegida })

      await this.createResultado({
        idPersonal: this.id,
        resultado,
      })
      await this.sendNotification()

      this.loading = false
      this.$router.push(this.rutaRetorno)
    },

    async sendNotification() {
      try {
        const notification = new NotificationFactory(Notificacion).createNotification(
          NOTIFICATION_TYPES.EMISION_RESULTADO_C3,
          {
            responsable: Number(localStorage.getItem('idPersonal')),
            afectado: this.id,
            nombrePersonal: this.getFullName(this.personal),
            resultado: this.resultadoElegido,
            fechaVigencia: moment(this.fechaElegida).format('DD/MM/YYYY'),
          }
        )

        await this.createNotification(notification)
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al notificar emisión de resultados.')
      }
    },
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(46, 38, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
}

::v-deep .v-card__title {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.2);
  background: rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.08);
}

.section-label {
  color: #e0e0e0;
}

::v-deep .modern-input .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.22) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

::v-deep .modern-input .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.4) !important;
}

::v-deep .modern-input .v-label,
::v-deep .modern-input textarea,
::v-deep .modern-input input,
::v-deep .modern-input .v-select__selection {
  color: #e0e0e0 !important;
}

::v-deep .modern-input.v-input--is-focused .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.15) !important;
}

::v-deep .modern-date-picker {
  border: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.2);
  border-radius: 16px;
  overflow: hidden;
  background: rgba(20, 20, 20, 0.25);
}

::v-deep .modern-date-picker .v-date-picker-header,
::v-deep .modern-date-picker .v-date-picker-table {
  background: transparent !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #1a1a1a !important;
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.28) !important;
}

::v-deep .ui-module-actions .ui-module-btn-text-danger {
  color: #ff6b6b !important;
}

::v-deep .ui-module-actions .primary--text {
  color: #1a1a1a !important;
}
</style>
